// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--Ww1DjjayjmcUj6Ao"};